module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card h-100"
  }, [(_vm.loading) ? _c('p', [_vm._v("Loading...")]) : _c('section', {
    staticClass: "modal-card-body d-block br-1"
  }, [_c('header', {
    staticClass: "d-flex align-items-center pb-3 space-between"
  }, [_c('h2', {
    staticClass: "fs-8"
  }, [_vm._v("Share this video")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tabs is-boxed mb-4"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': !_vm.linkMode
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.linkMode = !_vm.linkMode
      }
    }
  }, [_vm._v("People")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.linkMode
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.linkMode = !_vm.linkMode
      }
    }
  }, [_vm._v("Link")])])])]), _vm._v(" "), (!_vm.linkMode) ? _c('section', [_c('p', [_vm._v("Select people or teams to share your video with from the dropdown. Start typing a name to filter the results.")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "w-100 mr-2"
  }, [_c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "multiple": "",
      "label": "value",
      "options": _vm.shareables
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('span', {
          staticClass: "d-flex"
        }, [(option.star) ? _c('StarIcon', {
          staticStyle: {
            "margin-right": ".5rem"
          }
        }) : _vm._e(), _vm._v(" "), (option.team) ? _c('b', [_vm._v("Group:")]) : _vm._e(), _vm._v(" " + _vm._s(option.value))], 1)]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium",
    class: {
      'is-loading': _vm.sharingWithSelected
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selected.length === 0,
      "name": "Share"
    },
    on: {
      "click": _vm.shareVideo
    }
  }, [_vm._v("\n            Share\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.linkMode) ? _c('section', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('div', {
    staticClass: "field has-addons w-100"
  }, [_c('div', {
    staticClass: "control w-100"
  }, [_c('input', {
    ref: "share",
    staticClass: "input is-medium",
    attrs: {
      "disabled": !_vm.slugShareEnabled,
      "readonly": ""
    },
    domProps: {
      "value": _vm.shareURL
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "disabled": !_vm.slugShareEnabled
    },
    on: {
      "click": _vm.copyLink
    }
  }, [_vm._v("\n              Copy Link\n            ")])])]), _vm._v(" "), (!_vm.slugShareEnabled) ? _c('button', {
    staticClass: "control button is-primary is-medium is-outlined",
    class: {
      'is-loading': _vm.enablingSlugSharing
    },
    on: {
      "click": _vm.enableSlugSharing
    }
  }, [_vm._v("\n          Enable link sharing\n        ")]) : _vm._e(), _vm._v(" "), (_vm.slugShareEnabled) ? _c('button', {
    staticClass: "control button is-danger is-medium is-outlined",
    class: {
      'is-loading': _vm.disablingSlugSharing
    },
    on: {
      "click": function($event) {
        _vm.disableSlugSharing()
      }
    }
  }, [_vm._v("\n          Disable link sharing\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.linkMode) ? _c('section', [_c('hr'), _vm._v(" "), (_vm.showShareText) ? _c('span', {
    staticClass: "text-center text-italic"
  }, [(_vm.slugShareEnabled) ? _c('p', [_vm._v("This video has link sharing enabled")]) : _c('p', [_vm._v("This video isn't shared with any person or team.")])]) : _c('h1', {
    staticClass: "fs-6 text-center"
  }, [_vm._v("Shared With:")]), _vm._v(" "), _c('ul', {
    staticClass: "overflow-auto mh-35"
  }, [_vm._l((_vm.video.shares), function(vs) {
    return _c('li', {
      staticClass: "mb-1 d-flex justify-content-between"
    }, [_vm._v("\n            " + _vm._s(vs.user.name || vs.user.email) + "\n             "), (vs.creator == _vm.userId) ? _c('input', {
      staticClass: "button is-small is-danger is-outlined",
      class: {
        'is-loading': vs.unsharing, 'w-auto': true
      },
      attrs: {
        "type": "button",
        "value": "✕ Unshare"
      },
      on: {
        "click": function($event) {
          _vm.unshareVideo(vs.id)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.video.teamshares), function(ts) {
    return _c('li', {
      staticClass: "mb-1 d-flex justify-content-between"
    }, [_c('div', [_c('b', [_vm._v("Group:")]), _vm._v(" " + _vm._s(ts.team.name))]), _vm._v(" "), (ts.creator == _vm.userId) ? _c('input', {
      staticClass: "button is-small is-danger is-outlined",
      class: {
        'is-loading': ts.unsharing, 'w-auto': true
      },
      attrs: {
        "type": "button",
        "value": "✕ Unshare"
      },
      on: {
        "click": function($event) {
          _vm.unshareTeamVideo(ts.id)
        }
      }
    }) : _vm._e()])
  })], 2)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center mt-2"
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" Anyone in your group who has this link can see your video.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-243b88d0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareModal.vue
// module id = 996
// module chunks = 0